// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1zZRF","alertIcon":"ConfirmModal_alertIcon__1jBH-"};